'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _redux = require('redux');

var _ConfirmModal = require('../../contexts/ConfirmModal');

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _ModalConfirm = require('../../components/ModalConfirm');

var _modals = require('../../hoc/modals');

var _modals2 = _interopRequireDefault(_modals);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var GlobalConfirmModal = (0, _ModalConfirm.createModalConfirm)('globalConfirmModal');

var ConfirmModalProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ConfirmModalProvider, _React$Component);

  function ConfirmModalProvider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ConfirmModalProvider);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ConfirmModalProvider)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.confirm = function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var modals = _this.props.modals;
      modals.open('globalConfirmModal', options);
    }, _temp));
  }

  _createClass(ConfirmModalProvider, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return React.createElement(_ConfirmModal2.default.Provider, {
        value: {
          confirm: this.confirm
        }
      }, children, React.createElement(GlobalConfirmModal, null));
    }
  }]);

  return ConfirmModalProvider;
}(React.Component);

exports.default = (0, _redux.compose)(_modals2.default)(ConfirmModalProvider);